import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import Modal from 'shared/components/Modal';
import MoneyView from 'shared/components/MoneyView';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { actions } from 'actions';
import { selector } from './selector';

import './index.scss';

import * as iconSuccess from './static/img/success.svg';

interface Props {}

type Enhanced = Props &
  InjectedTranslateProps &
  ReturnType<typeof selector> &
  typeof mapDispatchToProps;

const b = b_.with('sell-submitted-modal');

const mapDispatchToProps = {
  close: actions.hideSellSubmittedModal,
};

const enhance = compose<Enhanced, Props>(translate, connect(selector, mapDispatchToProps));

class OrderSubmittedModal extends React.Component<Enhanced> {
  render() {
    const { t, close, amount } = this.props;
    return (
      <Modal className={b()} onClose={close}>
        <div className={b('content')}>
          <img src={iconSuccess} className={b('image')} alt="" />
          <h2 className={b('title')}>
            {t('Sell for')} <MoneyView cents>{amount}</MoneyView>
            {`...`}
          </h2>
          <p className={b('message')}>
            {t('Status of the order is at right bottom corner of investment card')}
          </p>
          <button className={b('btn')} onClick={close}>
            {t('Ok')}
          </button>
        </div>
      </Modal>
    );
  }
}

export default enhance(OrderSubmittedModal);
